import Onyx, { Image as OnyxPreview } from './onyx';
import Pikachu, { Image as PikachuPreview } from './pikachu';
import Gengar, { Image as GengarPreview } from './gengar';
import Castform, { Image as CastformPreview } from './castform';
import Glalie, { Image as GlaliePreview } from './glalie';
import Celebi, { Image as CelebiPreview } from './celebi';

export default [
  {
    key: 'onyx',
    name: 'Layout 1',
    component: Onyx,
    preview: OnyxPreview,
  },
  {
    key: 'pikachu',
    name: 'Layout 2',
    component: Pikachu,
    preview: PikachuPreview,
  },
  {
    key: 'gengar',
    name: 'Layout 3',
    component: Gengar,
    preview: GengarPreview,
  },
  {
    key: 'castform',
    name: 'Layout 4',
    component: Castform,
    preview: CastformPreview,
  },
  {
    key: 'glalie',
    name: 'Layout 5',
    component: Glalie,
    preview: GlaliePreview,
  },
  {
    key: 'celebi',
    name: 'Layout 6',
    component: Celebi,
    preview: CelebiPreview,
  },
];
